import { ImgHTMLAttributes } from 'react';
import noPreviewImage from '@/img/no-preview-image.svg';

type ImgProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'alt'> & {
  alt: string;
};

export function Img({ src, alt, className, onError, ...rest }: ImgProps) {
  return (
    <img
      {...rest}
      src={src}
      className={className}
      alt={alt}
      onError={(e) => {
        e.currentTarget.src = noPreviewImage;
        onError?.(e);
      }}
    />
  );
}
